export default __webpack_public_path__ + "static/media/user_profile_place_holder.70d14515.png";